angular
    .module('vm')
    .component('appAlert', {
        templateUrl: 'alert.component.html',
        bindings: {
            alert: '=',
            close: '&',
        },
        controllerAs: 'vm',
        controller: function () {
            const vm = this;

            vm.icon = null;

            const iconsByType = {
                'error': 'x-circle-filled',
                'success': 'checkmark-filled',
                'warning': 'info',
            };

            vm.$onInit = $onInit;

            ///////////

            function $onInit() {
                updateIcon();
            }

            function updateIcon() {
                if (vm.alert.icon) {
                    vm.icon = vm.alert.icon;
                } else {
                    vm.icon = iconsByType[vm.alert.type];
                }
            }
        }
    })
;